import type { QuoteStatusPayload } from './index';

/** `''` is the form's "no change in status" sentinel, the API wants `null`. */
export function toApiPayload(
  payload: QuoteStatusPayload,
): Omit<QuoteStatusPayload, 'next'> & { next: string | null } {
  return {
    ...payload,
    next: payload.next === '' ? null : payload.next,
  };
}
